/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useParams } from "react-router-dom";
import { Box, Spacer, Text } from "@nordcloud/gnui";
import { FlexContainer } from "~/components";
import { LoaderWrap } from "~/components/LoaderWrap/LoaderWrap";
import { useUserConsumer } from "~/context/User/User";
import { useAPIData } from "~/hooks/useAPIData";
import { CustomerService, RouteParams } from "~/models";
import { isPrivilegedUser } from "~/routing";
import AssignService from "./AssignService";
import ServiceItem from "./ServiceItem";

export default function () {
  const { customerId } = useParams<RouteParams>();

  const [services, loading, refetch] = useAPIData<CustomerService[]>(
    `/customers/${customerId}/service-offering`,
    (resp) => resp.services,
    []
  );

  const { role } = useUserConsumer();
  const canEdit = isPrivilegedUser(role);

  return (
    <Box>
      {canEdit && (
        <FlexContainer justify="flex-end">
          <AssignService refetch={refetch} assignedServices={services} />
        </FlexContainer>
      )}
      <Spacer height="1rem" />

      <LoaderWrap loading={loading}>
        {services.length ? (
          services.map((service) => (
            <ServiceItem
              key={service.id}
              service={service}
              refetch={refetch}
              canEdit={canEdit}
            />
          ))
        ) : (
          <Text>No services assigned.</Text>
        )}
      </LoaderWrap>
    </Box>
  );
}
